export function formatRewardScore(value) {
  if (value >= 0) return `+${+value.toFixed(2)}`;
  return `${+value.toFixed(2)}`;
}